/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { SparkJobRetryPolicy } from '../models/SparkJobRetryPolicy';
import { SparkJobSparkSubmitParams } from '../models/SparkJobSparkSubmitParams';
import { SparkJobStatus } from '../models/SparkJobStatus';

export class SparkJob {
  /**
  * The unique identifier of the Spark job
  */
  'id': string;
  /**
  * The name of the Spark job
  */
  'name': string;
  /**
  * The ID of the Spark engine this job runs on
  */
  'sparkEngineId': string;
  'status': SparkJobStatus;
  /**
  * The timestamp when the Spark job was created
  */
  'createdAt': Date;
  /**
  * Job timeout in seconds
  */
  'jobTimeout'?: number | null;
  'retryPolicy'?: SparkJobRetryPolicy | null;
  'sparkSubmitParams'?: SparkJobSparkSubmitParams;
  /**
  * The Spark-generated application ID (used for History Server links)
  */
  'sparkApplicationId'?: string | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "sparkEngineId",
      "baseName": "sparkEngineId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "status",
      "baseName": "status",
      "type": "SparkJobStatus",
      "format": ""
    },
    {
      "name": "createdAt",
      "baseName": "createdAt",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "jobTimeout",
      "baseName": "jobTimeout",
      "type": "number",
      "format": ""
    },
    {
      "name": "retryPolicy",
      "baseName": "retryPolicy",
      "type": "SparkJobRetryPolicy",
      "format": ""
    },
    {
      "name": "sparkSubmitParams",
      "baseName": "sparkSubmitParams",
      "type": "SparkJobSparkSubmitParams",
      "format": ""
    },
    {
      "name": "sparkApplicationId",
      "baseName": "sparkApplicationId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SparkJob.attributeTypeMap;
  }

  public constructor() {
  }
}



